import "../../../../src/pages/design/design-guidelines-styles.css";
import { Paragraph } from 'react-magma-dom';
import * as React from 'react';
export default {
  Paragraph,
  React
};